import { Close } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'

interface DrawerTitleProps {
  onClose: () => void
  title: string
}

export function DrawerTitle({ onClose, title }: Readonly<DrawerTitleProps>) {
  return (
    <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Typography variant="h5">{title}</Typography>
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </Box>
  )
}
